import React, { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import { CaretDown } from "phosphor-react";
import { twMerge } from "tailwind-merge";
import { KontentLink } from "./FooterLink";

export interface KontentDropdown {
  elements: {
    title: { value: string };
    links: { value: KontentLink[] };
  };
  system: {
    type: "dropdown";
  };
}

interface DropdownProps {
  title: string;
  children: React.ReactNode;
}

const Dropdown = ({ title, children }: DropdownProps) => {
  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <Popover.Button className="mx-auto flex items-center gap-2 font-body text-xl font-medium tracking-wide text-extraDarkPurple">
            <span>{title}</span>
            <CaretDown
              weight="bold"
              color="#2C143A"
              className={twMerge(
                "mt-1 transition-transform duration-200",
                open && "rotate-180"
              )}
            />
          </Popover.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="z-10 md:absolute md:right-1/2 md:translate-x-1/2 md:bg-warmWhite md:shadow-lg">
              <div className="flex min-w-max flex-col items-center gap-2 px-8 py-4">
                {children}
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default Dropdown;
